.heroWrapper {
	background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-8));
	border-bottom: rem(1px) solid var(--mantine-color-gray-2);
}

.inner {
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: calc(var(--mantine-spacing-xl) * 4);
	padding-bottom: calc(var(--mantine-spacing-xl) * 4);
	gap: calc(var(--mantine-spacing-xl) * 3);

	@media (max-width: $mantine-breakpoint-md) {
		flex-direction: column;
		align-items: center;
		gap: var(--mantine-spacing-xl);
		padding-top: var(--mantine-spacing-xl);
		padding-bottom: var(--mantine-spacing-xl);
	}
}

.content {
	flex: 1;
	max-width: 480px;

	@media (max-width: $mantine-breakpoint-md) {
		max-width: 100%;
	}
}

.image {
	width: rem(480px);
	height: rem(480px);
	flex-shrink: 0;
	shape-rendering: geometricPrecision;

	[data-mantine-color-scheme='dark'] & {
		filter: invert(1);
	}

	@media (max-width: $mantine-breakpoint-md) {
		width: rem(220px);
		height: rem(220px);
		order: -1;
	}
}

.title {
	color: light-dark(var(--mantine-color-black), var(--mantine-color-white));
	font-size: rem(54px);
	line-height: 1.2;
	font-weight: 900;

	@media (max-width: $mantine-breakpoint-xs) {
		font-size: rem(28px);
	}
}

.subtitle {
	font-weight: 300;
	font-size: rem(22px);
	text-transform: uppercase;
	letter-spacing: 8px;
	color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-3));

	@media (max-width: $mantine-breakpoint-sm) {
		font-size: rem(14px);
		letter-spacing: 4px;
	}
}

